import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TfHorizontalLineModule } from '@app/modules/horizontal-line/horizontal-line.module';
import { KomodoBadgeModule } from '@app/modules/komodo-badge';
import { KomodoButtonModule } from '@app/modules/komodo-button';
import { KomodoToggleModule } from "@app/modules/komodo-toggle";
import { TfChipModule } from '@app/modules/tf-chip';
import { TfCopyToClipboardModule } from '@app/modules/tf-copy-to-clipboard';
import { TfDropdownsModule } from '@app/modules/tf-dropdowns';
import { TfPricingModule } from '@app/modules/tf-pricing';
import { TfSharedListModule } from '@app/modules/tf-shared-list';
import { TfSearchResultRowComponent } from '@app/products/ge/assays/components/search-result-row/search-result-row.component';
import { TfCommonUIModule } from '@app/modules/tf-common-ui';
import { TfProductTypeSelectorModule } from '@app/modules/product-type-selector';
import { TfSearchFiltersModule } from '@app/modules/search-filters';
import { TfSearchFooterModule } from '@app/modules/search-footer';
import { TfSearchHeaderModule } from '@app/modules/search-header';
import { TfZeroResultsModule } from '@app/modules/zero-results';
import { TfErrorFilterModule } from '@app/modules/error-filter';
import { TfStickyToModule } from '@app/modules/tf-sticky-to';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { TfCheckboxModule } from '@app/modules/tf-checkbox';
import { TfSearchPageComponent } from './pages/search-page/search-page.component';
import { TfSearchResultsHeaderComponent } from '@app/products/ge/assays/components/search-results-header/search-results-header.component';
import { TfSortByModule } from '@app/modules/tf-sort-by';
import { TfPriceHeaderModule } from '@app/modules/tf-price-header';
import { TfResultCheckboxModule } from '@app/modules/tf-result-checkbox';
import { TfLoadingPageModule } from '@app/modules/tf-loading-page';

@NgModule({
    declarations: [
        TfSearchResultRowComponent,
        TfSearchResultsHeaderComponent,
        TfSearchPageComponent,
    ],
    exports: [
        TfSearchPageComponent
    ],
    imports: [
        CommonModule,
        TfCommonUIModule,
        TfProductTypeSelectorModule,
        TfStickyToModule,
        TfSearchFiltersModule,
        TfSearchFooterModule,
        TfSearchHeaderModule,
        TfZeroResultsModule,
        TfErrorFilterModule,
        TfCopyToClipboardModule,
        TfSharedListModule,
        TfDropdownsModule,
        TfPricingModule,
        TfChipModule,
        KomodoBadgeModule,
        NgbPopover,
        FormsModule,
        TfCheckboxModule,
        TfSortByModule,
        TfPriceHeaderModule,
        TfResultCheckboxModule,
        TfHorizontalLineModule,
        TfLoadingPageModule,
        KomodoButtonModule,
        KomodoToggleModule
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ]
})
export class TfAssaysModule {
}
